import { render, staticRenderFns } from "./FeaturesMetrics.vue?vue&type=template&id=5522c4a1&scoped=true&"
import script from "./FeaturesMetrics.vue?vue&type=script&lang=js&"
export * from "./FeaturesMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5522c4a1",
  null
  
)

export default component.exports